import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetAllLogisticsLoadLinesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.LoadLineDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.LoadLineDocumentSortInput> | Types.LoadLineDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetAllLogisticsLoadLinesQuery = { __typename?: 'Query', logisticsLoadLines?: { __typename?: 'LogisticsLoadLinesConnection', totalCount: number, nodes?: Array<{ __typename?: 'LoadLineDocument', id: string, tenantId: string, loadLineId: string, loadId: string, orderId: string, orderNumber: string, customerName: string, routeStopId?: string | null, containerCount?: number | null, updatedAt: Types.TDateISO, updatedBy: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type LogisticsLoadLineDocumentFieldsFragment = { __typename?: 'LoadLineDocument', id: string, tenantId: string, loadLineId: string, loadId: string, orderId: string, orderNumber: string, customerName: string, routeStopId?: string | null, containerCount?: number | null, updatedAt: Types.TDateISO, updatedBy: string };

export const LogisticsLoadLineDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsLoadLineDocumentFields on LoadLineDocument {
  id
  tenantId
  loadLineId
  loadId
  orderId
  orderNumber
  customerName
  routeStopId
  containerCount
  updatedAt
  updatedBy
}
    `, {"fragmentName":"LogisticsLoadLineDocumentFields"});
export const GetAllLogisticsLoadLinesDocument = new TypedDocumentString(`
    query GetAllLogisticsLoadLines($where: LoadLineDocumentFilterInput, $order: [LoadLineDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  logisticsLoadLines(
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...LogisticsLoadLineDocumentFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment LogisticsLoadLineDocumentFields on LoadLineDocument {
  id
  tenantId
  loadLineId
  loadId
  orderId
  orderNumber
  customerName
  routeStopId
  containerCount
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetAllLogisticsLoadLines: build.query<GetAllLogisticsLoadLinesQuery, GetAllLogisticsLoadLinesQueryVariables | void>({
      query: (variables) => ({ document: GetAllLogisticsLoadLinesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetAllLogisticsLoadLinesQuery, useLazyGetAllLogisticsLoadLinesQuery } = injectedRtkApi;
